// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import {
  buttonColors,
  ButtonComponent,
  buttonSizes,
  buttonVariants,
} from '../button/button.component';
// utils
import { goToPanelSignup } from '@shared/utils/goToExternalUrl';

@Component({
  standalone: true,
  selector: 'pwj-register-button',
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './register-button.component.html',
  styleUrl: './register-button.component.scss',
})
export class RegisterButtonComponent {
  variant = input<buttonVariants>('primary');
  color = input<buttonColors>('white');
  size = input<buttonSizes>('medium');
  title = input<string>('');

  public redirectToPanelSignup() {
    goToPanelSignup();
  }
}
